import API from './index';

const api = {
    getReviewPanelList({ params }) {
        return API.authAPI({
            url: '/review-panel/get-review-panel-list',
            method: 'GET',
            params: { ...params },
        });
    },
    deleteReviewPanel(id) {
        return API.authAPI({
            url: `/review-panel/${id}`,
            method: 'DELETE',
            params: null,
        });
    },
    getReviewPanelById(id) {
        return API.authAPI({
            url: `/review-panel/get-review-panel-detail/${id}`,
            method: 'GET',
        });
    },
    getReviewPanelMemberList({params}) {
        return API.authAPI({
            url: `/review-panel/get-review-panel-member-list`,
            method: 'GET',
            params: { ...params },
        });
    },
    addReviewPanel(data) {
        return API.authAPI({
            url: `/review-panel/add-review-panel`,
            method: 'POST',
            data,
        });
    },
    editReviewPanel({data,id}) {
        return API.authAPI({
            url: `/review-panel/edit-review-panel/${id}`,
            method: 'PUT',
            data,
        });
    },
};

export default api;
